import React from 'react';
import { BookOpen, Check } from 'lucide-react';
import { motion } from 'framer-motion';
const tomos = [{
  num: 1,
  title: 'Panadería Real Sin Glúten',
  desc: 'Pan de molde, baguettes y panes artesanales con miga aireada.',
  promise: 'Nunca más pan seco ni apelmazado en tu mesa.'
}, {
  num: 2,
  title: 'Desayunos y Meriendas Metabólicas',
  desc: 'Facturas, bizcochuelos y galletas sin picos de glucosa.',
  promise: 'El ritual del mate recuperado sin culpa ni miedo.'
}, {
  num: 3,
  title: 'Pizzas y Empanadas de Masa Elástica',
  desc: 'Bordes reales y masas que no se rompen.',
  promise: 'El sábado en familia sin sentirte excluida.'
}, {
  num: 4,
  title: 'Pastelería Sin Azúcar',
  desc: 'Tortas, brownies, cheesecake y postres de vitrina.',
  promise: 'Cumpleaños y reuniones sin resignación.'
}, {
  num: 5,
  title: 'Almuerzos y Cenas Criollas Rediseñadas',
  desc: 'Milanesas, guisos y platos de todos los días.',
  promise: 'La mesa familiar de siempre sin restricciones.'
}, {
  num: 6,
  title: 'Masas Finas y Croissants Laminados',
  desc: 'El arte de la pastelería de élite sin lactosa.',
  promise: 'Resultados de panadería profesional en tu casa.'
}];
const includes = ['Recetas que funcionan desde el primer intento', 'Técnicas que ningún video de YouTube te enseña', 'Ingredientes del súper de la esquina', 'Sustituciones que salvan cualquier receta', 'Porciones pensadas para tu glucosa', 'Paso a paso tan claro que no podés fallar', 'Para cocinar hoy y regalar mañana', 'Resultados que tu familia no va a poder creer'];
export function TomosGrid() {
  return <section className="py-20 px-4 bg-brand-base border-t border-brand-gold/15 relative overflow-hidden space-y-[-80px]" data-id="element-327">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-brand-gold/10 blur-[140px] rounded-full pointer-events-none" data-id="element-328"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-329">
        <div className="mb-10 text-center" data-id="element-330">
          <p className="text-brand-gold font-bold tracking-[0.2em] uppercase text-xs sm:text-sm mb-3 glow-gold" data-id="element-331">
            ✦ MEGAPACK COCINA SIN GLUTEN Y SIN AZÚCAR™ ✦
          </p>
          <h2 className="font-display text-3xl sm:text-5xl font-extrabold text-brand-gold mb-3 glow-gold" data-id="element-332">
            6 TOMOS MAESTROS
          </h2>
          <p className="text-base sm:text-lg text-brand-cream/80" data-id="element-333">
            Edición 2026 · +400 recetas · Todo resuelto.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-ink/70 backdrop-blur-sm rounded-3xl border border-brand-gold/25 p-6 sm:p-10 mb-10" style={{
        boxShadow: '0 30px 60px -20px rgba(0,0,0,0.6), inset 0 1px 0 rgba(212, 168, 67, 0.12)'
      }} data-id="element-334">
          <div className="flex items-center justify-center gap-2 mb-7" data-id="element-335">
            <span className="text-brand-gold/60" data-id="element-336">✦</span>
            <span className="font-display text-brand-gold font-bold text-lg sm:text-xl tracking-widest uppercase glow-gold" data-id="element-337">
              📚 6 TOMOS
            </span>
            <span className="text-brand-gold/60" data-id="element-338">✦</span>
          </div>

          <ul className="space-y-6 text-left" data-id="element-339">
            {tomos.map((tomo, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} className="flex items-start gap-4 pb-5 last:pb-0 border-b border-brand-gold/15 last:border-b-0" data-id="element-340">
                <div className="shrink-0 w-9 h-9 rounded-md border border-brand-gold/40 bg-brand-gold/10 flex items-center justify-center text-brand-gold mt-0.5" data-id="element-341">
                  <BookOpen size={16} data-id="element-342" />
                </div>
                <div className="flex-1" data-id="element-343">
                  <p className="font-bold text-brand-gold text-sm sm:text-base mb-1" data-id="element-344">
                    TOMO {tomo.num} —{' '}
                    <span className="text-brand-cream" data-id="element-345">{tomo.title}</span>
                  </p>
                  <p className="text-brand-cream/75 text-sm leading-relaxed mb-2" data-id="element-346">
                    {tomo.desc}
                  </p>
                  <p className="text-brand-gold/90 text-sm italic leading-snug" data-id="element-347">
                    → {tomo.promise}
                  </p>
                </div>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-ink/70 backdrop-blur-sm rounded-3xl border border-brand-gold/25 p-6 sm:p-10" data-id="element-348">
          <h3 className="font-display text-xl sm:text-2xl font-extrabold text-brand-gold mb-7 text-center glow-gold" data-id="element-349">
            ✦ Cada tomo incluye ✦
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 text-left" data-id="element-350">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-351">
                <Check size={16} className="text-brand-gold shrink-0 mt-1" strokeWidth={3} data-id="element-352" />
                <span className="text-brand-cream/90 font-medium text-sm sm:text-base leading-snug" data-id="element-353">
                  {item}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}